import React from 'react';

const About = () => {
  return (
    <div className="about">
      <section className="page-hero" style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/images/hero/hero-background.jpg'})`, backgroundSize: 'cover', backgroundPosition: 'center'}}>
        <div className="container">
          <h1 className="page-title">Our Mission</h1>
          <p className="page-subtitle">
            Empowering rural talent through education and training, connecting them with local and global virtual assistance opportunities while promoting sustainable work-life balance.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="grid grid-2">
            <div>
              <h2>Who We Are</h2>
              <p>
Rippluence is a virtual freelance community founded in Bohol. Freelancing can often feel isolating, but it doesn't have to be. At Rippluence, our goal is to ensure that no one has to navigate this journey alone. We've built a community where freelancers from various niches can thrive together.
              </p>
              <p>
  We provide a reliable support system for newcomers entering the virtual world and create a space for experienced professionals to connect. Additionally, we aim to be a safe haven for entrepreneurs and recruiters, assuring them that when they hire a member of Rippluence, they can count on the highest quality freelancers.
              </p>
            </div>
            <div style={{background: '#f0f0f0', borderRadius: '12px', minHeight: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
              <img src="/images/coverteam.png" alt="Community" style={{maxWidth: '100%', maxHeight: '100%', borderRadius: '12px'}} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;